/**
 * @generated SignedSource<<3a7c3dd233e1a75ee9bbe75020fe2471>>
 * @relayHash ea58328175b0ae5b55853f7ed439623d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec0c23b50893f6fb32939b1810d8251498843b255bacde77c7fb15db7a1f9a82

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContentType = "ATTACHMENT" | "BLOG_POST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ConfluencePageStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type HomeRecentAgentSessionsQuery$variables = {
  aqlQuery: string;
  first: number;
  shardingContext: string;
};
export type HomeRecentAgentSessionsQuery$data = {
  readonly agent_sessionQuery: {
    readonly nodes: ReadonlyArray<{
      readonly agent: {
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
      readonly associatedEntities: ReadonlyArray<{
        readonly __typename: "ConfluencePage";
        readonly id: string;
        readonly links: {
          readonly webUi: string | null;
        } | null;
        readonly pageId: string;
        readonly space: {
          readonly id: string;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly status: ConfluencePageStatus | null;
        readonly subtype: ConfluencePageSubType | null;
        readonly title: string | null;
        readonly type: ConfluenceContentType | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null> | null;
      readonly conversationChannel: {
        readonly name: string | null;
      } | null;
      readonly id: string | null;
      readonly isRovo: boolean | null;
      readonly lastStateChangeAt: AGG$Long | null;
      readonly state: string | null;
    } | null> | null;
  } | null;
};
export type HomeRecentAgentSessionsQuery = {
  response: HomeRecentAgentSessionsQuery$data;
  variables: HomeRecentAgentSessionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shardingContext"
},
v3 = [
  {
    "kind": "Variable",
    "name": "aqlQuery",
    "variableName": "aqlQuery"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "shardingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "state"
},
v6 = {
  "kind": "ScalarField",
  "name": "isRovo"
},
v7 = {
  "kind": "ScalarField",
  "name": "lastStateChangeAt"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = [
  {
    "kind": "Variable",
    "name": "workspaceAri",
    "variableName": "shardingContext"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "pageId"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webUi"
        }
      ]
    },
    {
      "concreteType": "ConfluenceSpace",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "key"
        },
        (v8/*: any*/)
      ]
    }
  ],
  "type": "ConfluencePage"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeRecentAgentSessionsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionConnection",
        "kind": "LinkedField",
        "name": "agent_sessionQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSession",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "args": (v10/*: any*/),
                "concreteType": "AgentConversationChannel",
                "kind": "LinkedField",
                "name": "conversationChannel",
                "plural": false,
                "selections": [
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "associatedEntities",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeRecentAgentSessionsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionConnection",
        "kind": "LinkedField",
        "name": "agent_sessionQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSession",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "args": (v10/*: any*/),
                "concreteType": "AgentConversationChannel",
                "kind": "LinkedField",
                "name": "conversationChannel",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "associatedEntities",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ea58328175b0ae5b55853f7ed439623d",
    "id": "ec0c23b50893f6fb32939b1810d8251498843b255bacde77c7fb15db7a1f9a82",
    "metadata": {},
    "name": "HomeRecentAgentSessionsQuery",
    "operationKind": "query",
    "text": "query HomeRecentAgentSessionsQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first,sort:\"lastStateChangeAt DESC\"){nodes{id,state,isRovo,lastStateChangeAt,agent{__typename,name,picture,id},conversationChannel(workspaceAri:$shardingContext)@optIn(to:\"AgentConversationChannelTeamEu26DemoOnly\"){name,id},associatedEntities{__typename,...on ConfluencePage{id,pageId,title,type,subtype,status,links{webUi},space{id,key,name}},...on Node{__isNode:__typename,id}}}}}"
  }
};
})();

(node as any).hash = "dcf964b79b96fa9a6797ec8e6f267d36";

export default node;
